// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import colors from "assets/theme/base/colors";
import { useMaterialUIController } from "context";

function IdCell({ id }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return (
    <MDBox display="flex" alignItems="center">
      <MDTypography
        // variant="caption"
        // fontWeight="medium"
        // // color="info"
        // sx={{ color: colors.grey[700] }}
        sx={({ typography: { size, fontWeightBold } }) => ({
          lineHeight: 0,
          fontSize: size.xs,
          fontWeight: fontWeightBold,
          color: darkMode ? "white" : colors.secondary.main,
        })}
      >
        {id}
      </MDTypography>
    </MDBox>
  );
}

// Typechecking props for the IdCell
IdCell.propTypes = {
  id: PropTypes.any,
};

export default IdCell;
